export function getGretaAIChatThinkingLabel({ fileName, t, text }) {
  return fileName ? t('Greta.StatusReadingFileKey', { fileName }) : text
}
